import {createStore, applyMiddleware,compose} from 'redux';
import {thunk} from 'redux-thunk';
import {persistStore, persistReducer} from 'redux-persist';
import reducers from './reducers';
import storage from 'redux-persist/lib/storage';


const persistConfig = {
    key: 'root',
    storage,
  };
  const persistedReducer = persistReducer(persistConfig, reducers);


export const store = createStore(persistedReducer,{},applyMiddleware(thunk));
export const persistor = persistStore(store);
